var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 16,
    rx: 8,
    fill: "#D81717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8073 5V11H11.6686L8.33882 6.91309H8.28016V11H7V5H8.14559L11.4719 9.08984H11.5341V5H12.8073Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2022 11V5H18.7984V5.91113H15.4824V7.54004H18.5603V8.45117H15.4824V10.0889H18.826V11H14.2022Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5916 11L19.5972 5H20.974L22.2472 9.40918H22.3128L23.6723 5H24.9249L26.2878 9.41211H26.35L27.6232 5H29L27.0056 11H25.7427L24.3279 6.79004H24.2727L22.8545 11H21.5916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPending);
export default __webpack_public_path__ + "static/media/status-pending.464b7346f9865662af77d3f4d8ea9c31.svg";
export { ForwardRef as ReactComponent };